/** EN uses Swedish values until translated. */
export const pagesStatisticsEn = {
    tabs: {
        trends: 'Trend graphs',
        scatterPlots: 'Matrices',
        issueMarket: 'The equity capital market',
        advisors: 'Advisor',
    },
    intro: {
        title: 'Statistics in Finance Lab',
        paragraph1: 'Through the statistics tool, you can filter, visualize and analyze data.',
        paragraph2: 'Initially, we have introduced a couple of different graph types:',
        listItem1: 'Trend graphs and matrices for rights issues',
        listItem2: 'As well as an overview of the equity capital market',
        paragraph3: 'The filters above affect what content is in the graphs and tables. Set the time period and settings that are relevant - experimentation is encouraged.',
        paragraph4: 'Please contact your contact person at Finance Lab with feedback and thoughts!',
        getStarted: 'Get started',
    },
    trends: {
        selectChart: 'Select graph',
        timeUnit: 'Time unit',
        selectSeries: 'Select series',
    },
    scatter: {
        issuesTitle: 'Issues',
        xAxis: 'X-axis',
        yAxis: 'Y-axis',
        size: 'Size',
    },
    issueMarket: {
        selectChart: 'Select graph',
        overview: 'Overview',
        ongoingIssues: 'Upcoming/ongoing FE',
        timeUnit: 'Time unit',
        yAxis: 'Y-axis',
        raisedSize: 'Raised capital',
        offerSize: 'Capital sought',
    },
    advisors: {
        advisorType: 'Type of advisor',
        selectAdvisorType: 'Select advisor type',
        segmentation: 'Segmentation',
        selectSegmentation: 'Select segmentation',
        advisorCount: 'Number of advisors: {{count}}',
        selectAtLeastOne: 'Select at least one type of advisor to view statistics.',
        loading: 'Loading...',
        noMatchingIssues: 'No issues match the filters for the selected advisor types.',
        unnamed: 'Unnamed',
        issueCountAxis: 'Number of issues',
        types: {
            financial_advisor: 'Financial advisors',
            legal_advisor: 'Legal advisors',
            issuing_agent: 'Issuing agents',
        },
        segmentationOptions: {
            none: 'No segmentation',
            issueType: 'Type of issue',
            offerSize: 'Size of offering',
            marketplace: 'Marketplace',
            year: 'Year',
        },
    },
}

/** Chart-specific labels for statistics views. Merged into charts.* in i18n. */
export const chartsStatisticsEn = {
    trendGraphs: {
        commitment: 'Secured level',
        subscription: 'Outcome',
        guarantorFee: 'Guarantee fee',
        discount: 'Discount',
        totalCommitment: 'Sub commitments and guarantors',
        commitmentOnly: 'Sub commitments',
        subscriptionQuota: 'Sub rate',
        subscriptionQuotaExclGuarantors: 'Sub rate ex. guarantors',
        feeCash: 'Fee in cash',
        feeUnits: 'Fee in shares/units',
        discount10d: 'Discount to 10 days VWAP',
        discount10dTerp: 'TERP discount to 10 days VWAP',
    },
    timeUnit: {
        quarter: 'Quarter',
        year: 'Year',
        month: 'Month',
    },
    issueType: {
        RE: 'RE',
        FE: 'FE',
        IPO: 'IPO',
        AE: 'AE',
    },
    offerSize: {
        '0–50 MSEK': '0–50 MSEK',
        '50–200 MSEK': '50–200 MSEK',
        '200–1 000 MSEK': '200–1 000 MSEK',
        '1 000+ MSEK': '1 000+ MSEK',
    },
    scatter: {
        selectAreaHint: 'Select an area to apply filter.',
        groups: {
            general: 'General',
            guarantorFee: 'Guarantor fee',
            priceChange: 'Share development',
            discounts: 'Discounts',
            commitment: 'Secured',
            outcome: 'Outcome',
        },
        axis: {
            avgTurnover: 'Turnover / day in SEK, prior to the issue (10d)',
            commitment: 'Commitments ex. guarantors (%)',
            dilutionActual: 'Dilution (actual)',
            dilutionMax: 'Dilution (max)',
            feeCash: 'Guarantor fee cash (%)',
            feeUnits: 'Guarantor shares/units (%)',
            offerSize: 'Size of offering in SEK',
            preMoney: 'Pre-money valuation',
            priceChangeMax: 'Share development max',
            priceChange3m: 'Share development 3m',
            priceChange6m: 'Share development 6m',
            priceChange12m: 'Share development 12m',
            subscribedSize: 'Subscriptions in SEK',
            subscriptionQuota: 'Subscription level (%)',
            subscriptionQuotaExclGuarantors: 'Subscription level ex. guarantors (%)',
            subscriptionQuotaExclGuarantorsAndCommitments: 'Subscription rate except SC (%)',
            totalCommitment: 'Secured level (%)',
            vwap10d: 'Discount to 10 days VWAP (%)',
            vwap10dTerp: 'TERP discount to 10 days VWAP (%)',
        },
    },
}
